// components
import ContactUsForm from "@/components/ContactUsForm";

// i18n
import { useTranslation } from "react-i18next";

const ContactUs = () => {
  const { t } = useTranslation();

  return (
    <div className="mx-auto max-w-[1200px] md:mb-[60px]">
      <div className="mb-15 mt-15 text-center text-5xl font-bold text-primary md:text-start">
        {t("contact_us.message_us")}
      </div>
      <div className="rounded-lg bg-[#f0f0f3] p-15">
        <ContactUsForm />
      </div>
    </div>
  );
};

export default ContactUs;
